// extracted by mini-css-extract-plugin
export default {"pl1":"LoaderSmall_pl1__AW-VG","pl1__a":"LoaderSmall_pl1__a__adahe","pl1__b":"LoaderSmall_pl1__b__2vIN4","pl1__c":"LoaderSmall_pl1__c__u96fv","bounce1":"LoaderSmall_bounce1__bBFRZ"};